<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <div @click="showColumn()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12xsl.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">显隐列</span>
        </div>
      </el-tooltip>
    </div>

    <!-- 检索 -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="80px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="关键词">
          <el-input placeholder="请输入关键词" v-model="input"></el-input>
        </el-form-item>

        <div class="margin-left20 margin-top10 margin-bot10">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()">重 置</el-button>
        </div>
      </el-form>
      <span
        class="attention margin-top10 margin-bot10 margin-left20 margin-right20"
        @click="tofinancingadd()"
        >新 增</span
      >
    </div>
    <el-skeleton
      class="width100 backwhite border-rd3"
      :loading="true"
      animated
      :throttle="500"
    >
      <template slot="template">
        <div
          class="
            width100
            backwhite
            pad-bot20 pad-top20
            margin-auto margin-top15
            border-rd3
            alldigital
          "
          v-if="total != 0"
        >
          <el-table
            :data="page"
            stripe
            style="width: 98%"
            class="eltable margin-auto f14"
          >
            <el-table-column
              v-if="columns[0].visible"
              label="项目名称"
              align="left"
              ><template slot-scope="scope">
                <span @click="Setasdefault(scope.row)" class="bluecolor">{{
                  scope.row.title
                }}</span></template
              ></el-table-column
            >
            <el-table-column
              v-if="columns[1].visible"
              label="融资机构"
              align="center"
              prop="institution"
            />
            <el-table-column
              v-if="columns[2].visible"
              label="融资金额"
              align="center"
              prop="fund"
            />
            <el-table-column
              v-if="columns[3].visible"
              label="融资方式"
              align="center"
              prop="way"
            />
            <el-table-column
              v-if="columns[4].visible"
              label="利率"
              align="center"
              prop="interest_rate"
            />
            <el-table-column
              v-if="columns[5].visible"
              label="到期时间"
              align="center"
              prop="end_time"
            />
            <el-table-column label="操作" v-if="columns[6].visible" width="180">
              <template slot-scope="scope">
                <span
                  class="bluecolor cursorpointer"
                  @click="Setasdefault(scope.row)"
                  >详情</span
                >
                <span
                  class="f14 cursorpointer bluecolor margin-left10"
                  @click="tofinancingmodify(scope.row)"
                  >修改
                </span>
                <span
                  class="f14 cursorpointer bluecolor margin-left10"
                  @click="downloadreport(scope.row)"
                  >删除
                </span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div
            class="flex-betweennowrap pad-top20 pad-right10"
            v-if="total != 0"
          >
            <span class="bluecolor"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleadd"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <aollectionadd></aollectionadd>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblemodify"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <aollectionmodify></aollectionmodify>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibledetily"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <aollectiondetily></aollectiondetily>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="open" append-to-body width="40%">
      <el-transfer
        :titles="['全选', '全选']"
        v-model="value"
        :data="columns"
        @change="dataChange"
      ></el-transfer>
    </el-dialog>
  </div>
</template>
<script>
import { entfinanceindex, entfinancedelete } from "@/api/business/business.api";
import BUS from "@/BUS/BUS";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import aollectionadd from "./Financing-add.vue";
import aollectionmodify from "./Financing-modify.vue";
import aollectiondetily from "./Financing-detail.vue";
export default {
  data() {
    return {
      loading: true,
      // 显隐数据
      value: [],
      // 弹出层标题
      title: "显示/隐藏",
      // 是否显示弹出层
      open: false,
      columns: [
        { key: 0, label: `项目名称`, visible: true },
        { key: 1, label: `融资机构`, visible: true },
        { key: 2, label: `融资金额`, visible: true },
        { key: 3, label: `融资方式`, visible: true },
        { key: 4, label: `利率`, visible: true },
        { key: 5, label: `到期时间`, visible: true },
        { key: 6, label: `操作`, visible: true },
      ],
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibleadd: false,
      dialogVisiblemodify: false,
      dialogVisibledetily: false,
      thisNum: 1,
      currentPage: 1,
      page: [],
      total: 0,
      per_page: 0,
      serchkey: true,
      input: "",
    };
  },

  components: {
    callback,
    switchcore,
    aollectionadd,
    aollectionmodify,
    aollectiondetily,
  },
  methods: {
    // 右侧列表元素变化
    dataChange(data) {
      for (let item in this.columns) {
        const key = this.columns[item].key;
        this.columns[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumn() {
      this.open = true;
    },
    submitForm() {
      if (this.input != "") {
        entfinanceindex({ _keywords: this.input, page: 1 }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.pagination = true;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },

    // 第一个分页
    currentchange(val) {
      // window.sessionStorage.setItem("financingval", val);
      this.thisNum = val;
      entfinanceindex({
        page: val,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.way == 1) {
              i.way = "银行贷款";
            } else if (i.way == 2) {
              i.way = "小贷公司贷款";
            } else if (i.way == 3) {
              i.way = "P2P融资";
            } else if (i.way == 4) {
              i.way = "融资租赁";
            } else if (i.way == 5) {
              i.way = "股票筹资";
            } else if (i.way == 6) {
              i.way = "债务融资";
            } else if (i.way == 7) {
              i.way = "信用担保融资";
            } else if (i.way == 8) {
              i.way = "股权融资";
            } else if (i.way == 9) {
              i.way = "增资扩股";
            } else if (i.way == 10) {
              i.way = "产权交易";
            } else if (i.way == 11) {
              i.way = "票据贴现";
            } else if (i.way == 12) {
              i.way = "贸易融资";
            } else if (i.way == 13) {
              i.way = "供应链融资";
            } else if (i.way == 14) {
              i.way = "信托融资";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      entfinanceindex({
        page: 1,
        limit: val,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.way == 1) {
              i.way = "银行贷款";
            } else if (i.way == 2) {
              i.way = "小贷公司贷款";
            } else if (i.way == 3) {
              i.way = "P2P融资";
            } else if (i.way == 4) {
              i.way = "融资租赁";
            } else if (i.way == 5) {
              i.way = "股票筹资";
            } else if (i.way == 6) {
              i.way = "债务融资";
            } else if (i.way == 7) {
              i.way = "信用担保融资";
            } else if (i.way == 8) {
              i.way = "股权融资";
            } else if (i.way == 9) {
              i.way = "增资扩股";
            } else if (i.way == 10) {
              i.way = "产权交易";
            } else if (i.way == 11) {
              i.way = "票据贴现";
            } else if (i.way == 12) {
              i.way = "贸易融资";
            } else if (i.way == 13) {
              i.way = "供应链融资";
            } else if (i.way == 14) {
              i.way = "信托融资";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置
    resetForm() {
      this.input = null;
      this.thisNum = 1;
      entfinanceindex({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    //跳转详情
    Setasdefault(row) {
      this.dialogVisibledetily = true;
      window.sessionStorage.setItem("Financingmodify", row.id);
      BUS.$emit("Financingmodify", row.id);
    },
    // 跳转新增
    tofinancingadd() {
      this.dialogVisibleadd = true;
    },
    //修改
    tofinancingmodify(row) {
      this.dialogVisiblemodify = true;
      window.sessionStorage.setItem("Financingmodify", row.id);
      BUS.$emit("Financingmodify", row.id);
    },
    //删除
    downloadreport(row) {
      this.$confirm("此操作将删除此项目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entfinancedelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      entfinanceindex({
        page: this.thisNum,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pagination = true;
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.way == 1) {
              i.way = "银行贷款";
            } else if (i.way == 2) {
              i.way = "小贷公司贷款";
            } else if (i.way == 3) {
              i.way = "P2P融资";
            } else if (i.way == 4) {
              i.way = "融资租赁";
            } else if (i.way == 5) {
              i.way = "股票筹资";
            } else if (i.way == 6) {
              i.way = "债务融资";
            } else if (i.way == 7) {
              i.way = "信用担保融资";
            } else if (i.way == 8) {
              i.way = "股权融资";
            } else if (i.way == 9) {
              i.way = "增资扩股";
            } else if (i.way == 10) {
              i.way = "产权交易";
            } else if (i.way == 11) {
              i.way = "票据贴现";
            } else if (i.way == 12) {
              i.way = "贸易融资";
            } else if (i.way == 13) {
              i.way = "供应链融资";
            } else if (i.way == 14) {
              i.way = "信托融资";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    // if (window.sessionStorage.getItem("financingval") == null) {
    //   this.thisNum = 1;
    //   this.currentPage1 = 1;
    // } else {
    //   this.thisNum = window.sessionStorage.getItem("financingval");
    //   this.currentPage1 = parseInt(
    //     window.sessionStorage.getItem("financingval")
    //   );
    // }

    entfinanceindex({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagination = true;
        this.page = res.data.data.data;
        this.page.forEach((i) => {
          if (i.way == 1) {
            i.way = "银行贷款";
          } else if (i.way == 2) {
            i.way = "小贷公司贷款";
          } else if (i.way == 3) {
            i.way = "P2P融资";
          } else if (i.way == 4) {
            i.way = "融资租赁";
          } else if (i.way == 5) {
            i.way = "股票筹资";
          } else if (i.way == 6) {
            i.way = "债务融资";
          } else if (i.way == 7) {
            i.way = "信用担保融资";
          } else if (i.way == 8) {
            i.way = "股权融资";
          } else if (i.way == 9) {
            i.way = "增资扩股";
          } else if (i.way == 10) {
            i.way = "产权交易";
          } else if (i.way == 11) {
            i.way = "票据贴现";
          } else if (i.way == 12) {
            i.way = "贸易融资";
          } else if (i.way == 13) {
            i.way = "供应链融资";
          } else if (i.way == 14) {
            i.way = "信托融资";
          }
        });
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("financingadd", (data) => {
      if (data == "yes") {
        this.dialogVisibleadd = false;
        this.dialogVisiblemodify = false;
        this.dialogVisibledetily = false;
        this.refresh();
      } else {
        this.dialogVisibleadd = false;
        this.dialogVisiblemodify = false;
        this.dialogVisibledetily = false;
      }
    });
  },
};
</script>
<style scoped>
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>